// src/app/services/resume-upload.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResumeUploadService {
  private apiUrl = '/TgNewUI/Profile/Home/ProfileUploadBuilder';

  constructor(private http: HttpClient) {}

  uploadResume(
    clientId: string,
    siteId: string,
    encryptedSessionId: string,
    source: string,
    Bruid: string,
    addFileType: string,
    downloadURL: string,
    uploadSource: string,
    authCode: string,
    fileNameWithExtension: string,
    workFlow: string,
    formData: FormData
  ): Observable<any> {
    // Append parameters to FormData
    formData.append('ClientId', clientId);
    formData.append('SiteId', siteId);
    formData.append('EncryptedSessionId', encryptedSessionId);
    formData.append('Source', source);
    formData.append('Bruid', Bruid);
    formData.append('AddFileType', addFileType);
    formData.append('downloadURL', downloadURL);
    formData.append('uploadSource', uploadSource);
    formData.append('authCode', authCode);
    formData.append('fileNameWithExtension', fileNameWithExtension);
    formData.append('workFlow', workFlow);

    return this.http.post(this.apiUrl, formData, {
      responseType: 'json',
      reportProgress: true // Track upload progress
    });
  }
  submitConsent(profileId: number, partnerId: number,useoldResume?:boolean): Observable<any> {
  return this.http.post(
    '/TgNewUI/Profile/Home/ResumeConsent',
    {
      profileId,
      partnerId,
      useoldResume: useoldResume || false
    }
  );
}
getDocumentDetail(
  partnerId: string,
  profileId: string
  
) {
  return this.http.post<any>(
    'rchilliservice/api/RchilliParseAndIndex/GetDocumentDetail',
    null,
    {
      params: {
        partnerId,
        profileId
       
      }
    }
  );
}
}